import SingleInventory from "./SingleInventory";
import MultipleInventory from "./MultipleInventory";

const Step2Inventory = ({ previousformData, nextStep, prevStep, productId, slug }) => {
  
  const productType = sessionStorage.getItem('productType') || previousformData.productType;

  const handleInventorySubmit = (inventoryData) => {
    nextStep(inventoryData);
  };

  return (
    <>
      <div className="card-header d-flex align-items-center justify-content-between">
        <h4>
          {productType === "Single"
            ? "Prices & Inventory"
            : "Variant Prices & Inventory"}
        </h4>
      </div>

      {productType === "Single" ? (
        <SingleInventory onSubmit={handleInventorySubmit} productId={productId} prevStep={prevStep} />
      ) : (
        <MultipleInventory onSubmit={handleInventorySubmit} baseSku={previousformData?.skuCode} productId={productId} slug={slug} prevStep={prevStep} />
      )}
    </>
  );
};

export default Step2Inventory;
